import {
  HR_CATEGORY_ID,
  INCIDENT_CATEGORY_ID,
  ITEM_ID_SEIZURE,
  ITEM_ID_SHORT_SEIZURE
} from '@lmc/common/types'
import _ from 'lodash'

const PERMITTED_RESIDENT_STATUSES = [
  'active',
  'hospitalised',
  'released',
  'dummy'
]

export const getSelectableResidents = <T extends { status?: string }>(
  residents: T[]
): T[] =>
  _.filter(residents, (resident) =>
    PERMITTED_RESIDENT_STATUSES.includes(resident.status as string)
  )

export const getSeizureTypeFields = (
  deEscalated: boolean,
  categoryItems: ReadonlyArray<{ id?: string; name?: string }> | undefined
) => {
  const item = deEscalated ? ITEM_ID_SHORT_SEIZURE : ITEM_ID_SEIZURE
  return {
    item,
    category: deEscalated ? HR_CATEGORY_ID : INCIDENT_CATEGORY_ID,
    title: categoryItems?.find((candidate) => candidate?.id === item)?.name
  }
}
